export default "__VITE_ASSET__eaBpPc1t__";